import { FC } from 'react';
import { useCreateModalStore } from './useCreateModalStore';

type CreateModalOptions<T extends string> = {
  name: T;
};

type CreateModalReturn<T extends string, P extends object | void = void> = {
  [K0 in `open${T}`]: P extends object ? (props: P) => boolean : () => boolean;
} & {
  [K1 in `close${T}`]: () => boolean;
};

export const createModal = <T extends string, P extends object | void = void>(
  Component: FC<P>,
  { name }: CreateModalOptions<T>,
) => {
  const open = (props: P) => {
    const { openModal } = useCreateModalStore.getState();

    openModal(Component, name, props);
  };

  const close = () => {
    const { closeModal } = useCreateModalStore.getState();

    closeModal(name);
  };

  return {
    [`open${name}`]: open,
    [`close${name}`]: close,
  } as CreateModalReturn<T, P>;
};
